import { Routes, Route, Link } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import Loading from '@/core/components/globals/loading'

const Welcome = lazy(() => import('@/pages/Welcome'))

export default function WelcomeLayout() {
  return (
    <div className="pre-signup-layout">
      <div className="pre-signup-layout__left-side">
        <Link to="/" className="pre-signup-layout__left-side__logo">
          <img alt="logo" width={100} height={28} src="/assets/images/sagebrush-logo.svg" style={{ objectFit: 'contain' }} />
        </Link>
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Loading /></div>}>
          <Routes>
            <Route path="/" element={<Welcome />} />
          </Routes>
      </Suspense>
      </div>
    </div>
  )
}
